module.exports = __webpack_public_path__ + "img/wemachurch.c3fb0b3e.jpeg";